import { useState, useEffect } from "react"

// Mui
import { Box, Stack, ToggleButton, Typography, styled, ToggleButtonGroup } from "@mui/material"

// Images
import Mellat from "public/images/mellat.png"
// Components
import MainCard from "src/components/common/main-card"
import Image from "next/image"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import "swiper/css"
import "swiper/css/navigation"
import { CustomContainer } from "./calc.styles"

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(1),
    border: `1px solid ${theme.palette.secondary.main}`,
    "&.Mui-disabled": {
      border: 0
    },
    "&:not(:first-of-type)": {
      borderRadius: "8px",
      border: `1px solid ${theme.palette.secondary.main}`
    },
    "&:first-of-type": {
      borderRadius: "8px",
      border: `1px solid ${theme.palette.secondary.main}`
    }
  }
}))

function LoanSliders({ data = [], onChange, isMobile = false, hideHeader = false }) {
  const [refund, setRefund] = useState(0)
  const [priceIndex, setPriceIndex] = useState(0)

  const handleRefund = (event, refundIndex) => {
    setRefund(refundIndex)
    onChange(priceIndex, refundIndex)
  }
  const handerSwiper = swiper => {
    const index = swiper.realIndex
    setPriceIndex(index)
    if (data[index]?.detail.length <= refund) {
      setRefund(0)
    }
    onChange(index, refund)
  }

  return (
    <MainCard shadow={0} sx={{ borderRadius: "25px", p: 3, px: isMobile ? 2 : 5 }}>
      {!hideHeader && (
        <>
          <Stack spacing={1} direction='row' justifyContent='center' alignItems='center' mb={2}>
            <Image src={Mellat} alt='بانک ملت' width={isMobile ? 30 : 40} />
            <Typography variant='h5' fontWeight={600}>
              تامین اعتبار بانک ملت
            </Typography>
          </Stack>
          <Typography typography={isMobile ? "h5" : "h4"} fontWeight='bold' textAlign={isMobile ? "center" : "initial"}>
            محاسبه گر اقساط
          </Typography>
          <Typography color='textSecondary'>مبلغ درخواستی و مدت‌زمان باز‌پرداخت را مشخص کنید.</Typography>
        </>
      )}
      <Stack direction='row' justifyContent='space-between' mt={6}>
        <Typography variant='h5'>مبلغ درخواستی </Typography>
      </Stack>
      <CustomContainer sx={{ mt: 2 }}>
        <Swiper spaceBetween={18} modules={[Navigation]} navigation={true} onRealIndexChange={handerSwiper}>
          {data?.map((item, index) => (
            <SwiperSlide key={index}>
              <MainCard
                sx={{
                  py: 2,
                  borderRadius: "15px"
                }}
                shadow={0}
              >
                <Stack direction='row' justifyContent='center' alignItems='center'>
                  <Stack>
                    <Typography color='primary' variant='h5' textAlign='center'>
                      {Number(item.amount).toLocaleString()} ریال
                    </Typography>
                  </Stack>
                </Stack>
              </MainCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </CustomContainer>
      <Box sx={{ mt: 4 }}>
        <Stack direction='row' justifyContent='center'>
          <Typography color='primary' fontWeight={600}>
            مدت بازپرداخت
          </Typography>
        </Stack>
        <Stack direction='row' justifyContent='center'>
          <StyledToggleButtonGroup
            value={refund}
            exclusive
            onChange={handleRefund}
            size='small'
            sx={{ mt: 1 }}
            color='secondary'
            aria-label='Platform'
          >
            {data[priceIndex]?.detail?.map((item, index) => (
              <ToggleButton
                key={index}
                size={isMobile ? "small" : "medium"}
                color='secondary'
                value={index}
                sx={{ px: isMobile ? 2 : 5, mx: 2 }}
              >
                <Typography fontWeight={600} color='primary'>
                  {item.installmentCount} ماهه
                </Typography>
              </ToggleButton>
            ))}
          </StyledToggleButtonGroup>
        </Stack>
      </Box>
    </MainCard>
  )
}
export default LoanSliders
